import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowLink",
  "use": "ArrowLink-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"ArrowLink\"><path fill-rule=\"evenodd\" d=\"M9.487 10.662a10.74 10.74 0 0 0-8.088 3.67c.989-4.237 4.797-7.403 9.33-7.403h.575V2.775l6.07 6.07-6.07 6.07v-4.11l-.504-.062a10.732 10.732 0 0 0-1.313-.08zM19 8.845L10.155 0v5.795a10.651 10.651 0 0 0-7.012 3.127A10.66 10.66 0 0 0 0 16.51v2.243l1.079-1.966a9.586 9.586 0 0 1 9.076-4.95v5.855L19 8.845z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol